import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import { BottomLine } from "../../../components";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

import {
  FaHtml5,
  FaCss3Alt,
  FaNodeJs,
  FaReact,
  FaPython,
  FaGithub,
} from "react-icons/fa";
import {
  SiJavascript,
  SiTailwindcss,
  SiExpress,
  SiMongodb,
  SiAdobephotoshop,
  SiFirebase,
  SiCsharp,
  SiTypescript,
} from "react-icons/si";

import { DiSass } from "react-icons/di";
import {
  headingAnimation,
  sectionBodyAnimation,
} from "../../../hooks/useAnimation";

import man from "../../../assets/man.json";

const MySkill = () => {
  const [viewDiv, setViewDiv] = useState(false);
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      setViewDiv(true);
    } else {
      setViewDiv(false);
    }
  }, [inView]);

  const languages = [
    { title: "HTML", icon: <FaHtml5 className="text-orange-600" /> },
    { title: "CSS", icon: <FaCss3Alt className="text-blue-400" /> },
    {
      title: "JavaScript",
      icon: <SiJavascript className="text-yellow-500 rounded" />,
    },
    { title: "Python", icon: <FaPython className="text-blue-400" /> },
    { title: "C#", icon: <SiCsharp className="text-grey-700" /> },
    { title: "TypeScript", icon: <SiTypescript className="text-cyan-600" /> },
  ];
  const frameworks = [
    { title: "React.JS", icon: <FaReact className="text-cyan-400" /> },
    { title: "Node.JS", icon: <FaNodeJs className="text-green-600" /> },
    { title: "ExpressJS", icon: <SiExpress className="text-neutral" /> },
    { title: "Tailwind", icon: <SiTailwindcss className="text-cyan-400" /> },
    { title: "SASS", icon: <DiSass className="text-pink-400" /> },
  ];
  const tools = [
    { title: "MongoDB", icon: <SiMongodb className="text-green-500" /> },
    { title: "GitHub", icon: <FaGithub className="text-white" /> },
    { title: "Firebase", icon: <SiFirebase className="text-yellow-500" /> },
    {
      title: "Photoshop",
      icon: <SiAdobephotoshop className="text-cyan-800" />,
    },
  ];

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: man,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <div className="pt-24">
      <motion.div
        initial="hidden"
        animate={viewDiv && "visible"}
        variants={headingAnimation}
      >
        <h3 className="text-center text-neutral">What I Learned</h3>
        <h1 className="text-4xl font-semibold drop-shadow-md text-center mb-5">
          My <span className="text-primary">Skills</span>
        </h1>
        <BottomLine />
      </motion.div>

      <motion.div
        ref={ref}
        initial="hidden"
        animate={viewDiv && "visible"}
        variants={sectionBodyAnimation}
      >
        <div className="flex flex-col md:flex-row items-center justify-evenly my-8">
          <div>
            <h2 className="text-cyan-500 text-xl font-semibold">Languages:</h2>
            <div className="flex flex-wrap mb-4">
              {languages?.map((skill) => (
                <div key={skill.title} className="text-center m-3">
                  <div
                    className="rounded-lg h-12 w-12 hover:-translate-y-2 duration-300 flex items-center justify-center text-3xl cursor-pointer shadow-lg hover:shadow-xl bg-[#313131] hover:bg-[#262626] mx-auto"
                    title={skill.title}
                  >
                    {skill?.icon}
                  </div>
                </div>
              ))}
            </div>
            <h2 className="text-cyan-500 text-xl font-semibold">
              Library & Frameworks:
            </h2>
            <div className="flex flex-wrap mb-4">
              {frameworks?.map((skill) => (
                <div key={skill.title} className="text-center m-3">
                  <div
                    className="rounded-lg h-12 w-12 hover:-translate-y-2 duration-300 flex items-center justify-center text-3xl cursor-pointer shadow-lg hover:shadow-xl bg-[#313131] hover:bg-[#262626] mx-auto"
                    title={skill.title}
                  >
                    {skill?.icon}
                  </div>
                </div>
              ))}
            </div>
            <h2 className="text-cyan-500 text-xl font-semibold">
              Tools & Technologies:
            </h2>
            <div className="flex flex-wrap mb-4">
              {tools?.map((skill) => (
                <div key={skill.title} className="text-center m-3">
                  <div
                    className="rounded-lg h-12 w-12 hover:-translate-y-2 duration-300 flex items-center justify-center text-3xl cursor-pointer shadow-lg hover:shadow-xl bg-[#313131] hover:bg-[#262626] mx-auto"
                    title={skill.title}
                  >
                    {skill?.icon}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <Lottie options={defaultOptions} height={400} width={360} />
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default MySkill;
